module.exports = __webpack_public_path__ + "img/layer2Blobs-PinkBlue.556a205d.svg";